import { v4 as uuid } from 'uuid';
import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permission from 'api/Apollo/permissions';
import { GET_EVENT_NAMES } from 'api/event-names/event-names-query-builder';
import { GET_ALL_EVENT_NAMES } from 'api/event-names/all-event-names-query-builder';

import {
  mutation as insertEventNameMutation,
  buildVariables as buildInsertEventNameVariables,
} from './insert-event-name-mutation-builder';

export default function useInsertEventName(options = {}) {
  const [trackWithUser] = useTrackWithUser('event_name_created');
  const [executeMutation, response] = useMutation(insertEventNameMutation, {
    ...options,
    refetchQueries: [{ query: GET_ALL_EVENT_NAMES }, GET_EVENT_NAMES],
    context: { permission: permission.createEventNames },
  });

  const insertEventName = async ({ name, description }) => {
    const id = uuid();
    const response = executeMutation({
      variables: buildInsertEventNameVariables({ id, name, description }),
    });

    if (!response.errors) {
      trackWithUser();
    }

    return response;
  };

  return [insertEventName, response];
}
